import {Component, NgModule, OnInit, ViewChild, signal} from '@angular/core';
import { AddMasterProductComponent } from './add-master-product/add-master-product.component';
import { MatDialog } from '@angular/material/dialog';
import { BASE_URL } from '../../../config/config';
import { DeleteMasterProductComponent } from './delete-master-product/delete-master-product.component';
import { MessagePopupComponent } from '../../bulk-upload/modals/message-popup/message-popup.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MasterdataService } from '../../services/masterdata.service';
import { PaginationComponent } from '../../common/pagination/pagination.component';
import { MatDialogModule } from '@angular/material/dialog';

import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';  

@Component({
  selector: 'app-master-bodyparts',
  standalone: true,
  imports: [CommonModule,FormsModule,PaginationComponent],
  templateUrl: './master-bodyparts.component.html',
  styleUrls: ['./master-bodyparts.component.scss', '../../../app.component.scss']
})
export class MasterBodypartsComponent implements OnInit{
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;

  totalBodyPartsCount: number = 0;
  responseData: any;
  public alerts: any = []
  public delete: any = []  
  public masterType: string = "bodyparts";
  public fileType = "";
  public isFile = false;
  searchTerm: string = ''; 
  public uploadedFile: any;
  public statusType: string = "";
  public statusMessage: string = ""; 
  public bodyparts: any = []
  public isDragOver = signal(false);
  product: any;
  public searchInput: string = "";
  public encodedSearchInput: string = "";
  public isSearch = false;
  public totalPages: number = 0;
  public currentPage: number = 1;
  public paginationData: any;
  public search : any = [];

  public selectedStatus = [];

  public isFilter = false;
  public isFilterResult = true;

  public BASE = BASE_URL.URL;

  constructor(private spinnerService: NgxSpinnerService,public dialog: MatDialog, public masterdataService: MasterdataService, public router: Router) { }

  ngOnInit(): void {
    this.getMasterBodyParts(this.search,this.currentPage)
  }

  @NgModule({
    imports: [
      MatDialogModule,
    ],
  })

  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file)
    }

    this.isDragOver.set(false);
  }

  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);
  }

  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  browseFile(e){
    e.preventDefault();
    let fileInput: any = document.getElementById("masterbodypartswrapper").querySelector('[id="file-input"]');
    if (fileInput) fileInput.click();
  }

  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  onFileChange(event){
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  onSubmit() {
    this.spinnerService.show(); 
    let formData = new FormData();
    
    formData.append('file', this.uploadedFile);
    let loggedUser = JSON.parse(localStorage.getItem('role'));
    formData.append('warehouse_id', loggedUser.resource_id);

    let token = localStorage.getItem('token');

    fetch(`${this.BASE}/bulk-stocks/master/upload/${this.masterType}`, {
      method: 'POST', 
      body: formData,
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then((response)=>{
      if (response.status === 200) {
        if (response.headers.get('Content-Type') === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
          const uploadeEntries = response.headers.get('Uploaded-Entries');
          const invalidEntries = response.headers.get('Invalid-Entries');
          let fileName = `${this.masterType}-${this.fileType}-error`;
          return response.blob().then((blobContent) => {
            this.getMasterBodyParts(this.search,this.currentPage);
            this.openDialogBrowse(blobContent, uploadeEntries, invalidEntries, fileName);
          })
        }else if(response.headers.get('Content-Type') === "application/json"){
          this.statusType = 'success';
          this.statusMessage = `The ${this.uploadedFile.name} data has been uploaded successfully!`;
          this.showWarningToast();
          this.getMasterBodyParts(this.search,this.currentPage);
        }
      }

      if (response.status === 204) {
        this.statusType = 'success';
        this.statusMessage = 'Nothing to update';
        this.showWarningToast();
      }

      if (response.status === 422) {
        this.statusType = 'error';
        this.statusMessage = 'Unprocessable Content';
        this.showWarningToast();
        
        response.json().then((jsonData) =>{
          if (!jsonData.data.excluded) {
            this.statusType = 'error';
            this.statusMessage = 'Error: The uploaded file and uploaded for doesn’t match';
            this.showWarningToast();
          }
        })
      }

      if (response.status === 401) {
        localStorage.clear();
        this.router.navigateByUrl('/login');
        this.spinnerService.hide();
        return;
      }

      if (response.status === 500) {
        this.statusType = 'error';
        this.statusMessage = `Oops, Something went wrong!`;
        this.showWarningToast();
      }
    })
    .catch((err)=>{
      this.spinnerService.hide();
      console.log('err', err);
    }).finally(()=>{
      this.spinnerService.hide();
    })
  }


  fileValidation(file){
    console.log("showWarningToast", file)
    const validFileTypes = ['csv', 'xlsx', 'xls'];
    let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (validFileTypes.includes(ext)) {
      this.isFile = true;
      this.fileType = ext;
      this.uploadedFile = file;
    }else{
      this.statusType = 'error';
      this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
      this.showWarningToast();
    }
  }

  resetFile(){
    this.isFile = false;
    this.fileType = '';
  }

  showWarningToast(){
    const toastContainer = document.getElementById('warning-toast');

    if (toastContainer) {
      setTimeout(function() {
        toastContainer.classList.add('show');
      }, 100);
      setTimeout(function() {
        toastContainer.classList.remove('show');
      }, 5000);
    }
  }

  downloadBulkUploadTemplate(bodyparts) {
    console.log(bodyparts);
    this.masterdataService.downloadBulkUploadTemplate(bodyparts);
  }

  openDialogBrowse(blob, uploadeEntries: string, invalidEntries: string, fileName: string): void {
    const dialogRef = this.dialog.open(MessagePopupComponent, {
      data: {
        blob,
        uploadeEntries, 
        invalidEntries,
        fileName
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  openDialog(): void { 
    console.log("bodyadd")
      const dialogRef = this.dialog.open(AddMasterProductComponent, {
        disableClose: true,
        data: {
          // passing type as add to inform AddMasterProductComponent that we are going to add product
          type: "add", 
        }
      }).afterClosed().subscribe(() => this.getMasterBodyParts(this.search,this.currentPage));
  }

  openDeleteDialog(item: any): void {
    const dialogRef = this.dialog.open(DeleteMasterProductComponent, {
      // no need to pass anything bcz will manage id in parent
    }).afterClosed().subscribe(result=>{
      if(result == "confirm"){
        // after we get confirm keyword from DeleteMasterProductComponent will get the id
        this.masterdataService.deleteBodyParts(item.id, "body_parts").subscribe((res:any)=>{
          if(res && res.success){
            this.getMasterBodyParts(this.search,this.currentPage);
          }
        })
      }
    });

  }

// while calling openEditDialog I'm passing particular clicked item
  openEditDialog(bodyparts: any): void {
    console.log("openeditbody", bodyparts)
      const dialogRef = this.dialog.open(AddMasterProductComponent, {
        disableClose: true,
        data: {
          // passing type as edit to inform the component we need to edit
          type: "edit",
          // passing that item to AddMasterProductComponent
          item: bodyparts
        }
      }).afterClosed().subscribe(() => 
      this.getMasterBodyParts(this.search,this.currentPage));
  }

  getMasterBodyParts(search: string = "", currentPage: number){
    this.masterdataService.getMasterBodyParts(search, currentPage).subscribe((res)=>{
      if (res.data) {
        this.bodyparts = res.data.data;
        this.paginationData = res.data.data;
        this.totalBodyPartsCount =  res.data.total;
        this.paginationData.totalPage = Math.ceil(res.data.total / 15);
        console.log(this.paginationData, " paginationData");
      }
    });
  }

  getQueryPage(event:any){
    console.log(event);
    this.currentPage = event;
    this.getMasterBodyParts(this.search,this.currentPage)
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      if (this.isFilter) { 
        this.isFilter = false;
        this.isFilterResult = true;
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      this.getMasterBodyParts(this.encodedSearchInput, this.currentPage);
    }
  }

  searchByBodyPartName(): void {
    this.bodyparts = this.bodyparts.filter((bodypart: any) =>
      bodypart.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.selectedStatus = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      this.getMasterBodyParts(this.encodedSearchInput, this.currentPage);
    }
  }

  // searchByBodyPartName(){ 
  //   if (this.searchInput !== "") {
  //     this.isSearch = true; 
  //     this.encodedSearchInput = encodeURIComponent(this.searchInput);
  //     if (this.currentPage > 1) {
  //       this.currentPage = 1;
  //       // this.paginationView.onCurrentPageChange(this.currentPage);
  //     }
  //     this.getMasterBodyParts("", this.encodedSearchInput);
  //   }
  // }

  resetSearch(): void {
    this.searchTerm = '';
    this.getMasterBodyParts(this.encodedSearchInput, this.currentPage);
  }

}
